import React from "react";
import { connect } from "react-redux";
import AuthFooter from "../Common/AuthFooter";
import AuthHeader from "../Common/AuthHeader";
import SideMenu from "../Common/SideMenu";
import ContactSection from "./ContactSection";
import { useGetAPICallQuery } from '../../app/services/account';

const Mysafe = (props) => {
  const mediaList = useGetAPICallQuery("media");

  return (
    <React.Fragment>
      <AuthHeader />
      <div className="momentio-dashboard-container">
        <SideMenu view="mysafe" />
        <div className="auth-content">
          <ContactSection title={props.form.language.MYCONTACT_S5} addTitle={props.form.language.CONTACT_LABEL_CAPS} />
        </div>
      </div>
      <AuthFooter />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return { ...state };
};

export default connect(mapStateToProps)(Mysafe);
